import { __decorate } from "tslib";
import { injectable } from 'inversify';
import { getWsFullImagesApi } from '@cores/apis/workspace_api/patents';
import _ from 'lodash';
let QueryPatentImagesServiceImpl = class QueryPatentImagesServiceImpl {
    async queryPatentImages(data) {
        const result = await this._queryPatentImagesRepository(data);
        return result;
    }
    async _queryPatentImagesRepository(data) {
        // @ts-ignore
        const resp = await getWsFullImagesApi(data);
        const total = _.get(resp, 'data.data.PDF_IMAGE_COUNT', 0);
        const records = _.get(resp, 'data.data.PDF_IMAGE', []);
        const images = records.map((record) => {
            return {
                imageId: record.IMAGE_ID,
                imageUrl: record.storage_path || record.fulltext_image240_url,
                patentId: data.patentId,
            };
        });
        return {
            total,
            images,
        };
    }
};
QueryPatentImagesServiceImpl = __decorate([
    injectable()
], QueryPatentImagesServiceImpl);
export { QueryPatentImagesServiceImpl };
